import { PropsWithChildren } from 'react'

/**
 * Layout for builder content area.  Note that CSS classes refer explicitly to
 * "preview", but these are suitable for general-purpose content.
 */
export function Layout(props: PropsWithChildren) {
  return (
    <div className="builders__preview-text-container">{props.children}</div>
  )
}

/**
 * Styled title for content area.
 */
export function Title(props: PropsWithChildren) {
  return <div className="builders__preview-title">{props.children}</div>
}

/**
 * Styled subtitle for content area.
 */
export function Subtitle(props: PropsWithChildren) {
  return <div className="builders__preview-subtitle">{props.children}</div>
}

/**
 * Styled description for content area.
 */
export function Description(props: PropsWithChildren) {
  return <div className="builders__preview-description">{props.children}</div>
}

/**
 * Styled caption for content area.
 */
export function Caption(props: PropsWithChildren) {
  return <div className="builders__preview-caption">{props.children}</div>
}

/**
 * Flex col container for main content; dark text w 1em gap.
 */
export function Main(props: PropsWithChildren) {
  return <div className="builders__content-main">{props.children}</div>
}
